@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.footer {
  display: grid;
  grid-template-columns: auto 1fr auto;
  padding: 8px;
  border-top: 1px solid @fulfillment-planner--rate-create-label-footer--border-color;
  line-height: 1.5;
  .hide-cost-review-link {
    visibility: hidden;
  }
}

.rate-recommendation {
  margin: @space-8 0 @space-16 0;
}

.misc-section {
  display: flex;
  padding: 0 8px 8px;
  flex-wrap: wrap;

  > * {
    font-size: 12px;
    font-weight: 500;
    color: @fulfillment-planner--rate-create-label--text-color;
    line-height: 1.5;
  }
}

.service-alone {
  width: 100%;
  padding-bottom: 8px;
}

.service-name,
.pickup-or-delivery-time {
  font-weight: @normal;
}

.truncate {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
